import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e27b3c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sd_card = _resolveComponent("sd-card")!

  return (_openBlock(), _createBlock(_component_sd_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString($props.number), 1),
      _createElementVNode("h2", null, _toDisplayString($props.title), 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }))
}